import { render, staticRenderFns } from "./some.vue?vue&type=template&id=139317f5&scoped=true&"
import script from "./some.vue?vue&type=script&lang=js&"
export * from "./some.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139317f5",
  null
  
)

export default component.exports